module.exports = __webpack_public_path__ + "img/arrow.4128abdc.svg";